<template>
  <loading-contributors v-if="panelLoading || !author" />

  <view-section
    v-else
    :title="$t('author')"
    :padding-x="false"
    :padding-y="false"
    :panel-loading="panelLoading"
  >
    <base-link
      class="tw-flex tw-justify-between tw-w-full"
      :link-primary="false"
      :to="{
        name: USER_GUIDE_BROWSE_ROUTE,
        params: { user: author?.username.toLowerCase() },
      }"
    >
      <div
        :class="[
          Classes.CONTRIBUTOR,
          'tw-w-full first:tw-pt-4 last:tw-pb-4 tw-p-4 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-white last:tw-border-b-0 tw-space-x-2 game-tile-background-color-hover',
        ]"
      >
        <div class="tw-flex tw-items-center tw-space-x-2">
          <avatar-icon show-status :user="author" size="md" />
          <span class="tw-font-bold tw-text-h6 mod-util-truncate-one-line">
            {{ author?.username }}
          </span>
        </div>
        <follow-button
          class="tw-z-1"
          simple-mode
          :disabled="user?.id === getUserId()"
          :user="user"
        />
      </div>
    </base-link>
  </view-section>
</template>

<script>
import LoadingContributors from '@components/Loading/LoadingContributors.vue'
import FollowButton from '@shared/components/Profile/FollowButton.vue'
import { USER_GUIDE_BROWSE_ROUTE } from '@config/routeNames.js'
import ViewSection from '@components/View/ViewSection.vue'
import AvatarIcon from '@components/Users/AvatarIcon.vue'
import Classes from '@shared/js/config/css.js'
import { Settings } from '@config/game.js'
import { computed, toRefs } from 'vue'
import { authStore } from '@stores'

export default {
  components: {
    LoadingContributors,
    FollowButton,
    ViewSection,
    AvatarIcon,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    panelLoading: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { user } = toRefs(props)

    const { getUserId } = authStore()

    const author = computed(() => {
      if (user.value !== null) {
        return {
          id: user.value.id,
          name_id: user.value.name_id,
          username: user.value.username,
          avatar: user.value.avatar,
          date_online: user.value.date_online,
        }
      }
      return null
    })
    return {
      USER_GUIDE_BROWSE_ROUTE,
      getUserId,
      Settings,
      Classes,
      author,
    }
  },
}
</script>
